<template>
    <v-container class="px-1 mt-2">
        <v-row class="px-1 mx-1">
            <v-col class="px-1 py-1 timestamp">{{ timestamp }}</v-col>
        </v-row>
        <v-row class="px-1 mx-1 mb-1">
            <v-col class="px-1 py-1 text"> {{ text }}</v-col>
        </v-row>
        <hr>
    </v-container>
</template>
<script>

const moment = require('moment');

export default {
    name: 'Note',
    props: {
        note: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.setup();
    },
    data: () => ({
        timestamp: '',
        text:''
    }),
    methods: {
        setup() {
            if (this.note.comment) {
                if (this.note.userFullName) {
                    this.text = this.note.userFullName + ': ' + this.note.comment
                } else this.text = this.note.comment;
            }
            if (this.note.eventTimeStamp) {
                this.timestamp = moment(this.note.eventTimeStamp).format('YYYY-MM-DD HH:mm');
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.text, .timestamp {
    font-size: 14px;
}
</style>